module.exports = __webpack_public_path__ + "img/dwarf_13.1b104a3b.png";